import { HomeView } from "./useHomeView";
import classes from "./home.module.scss";

type Props = {
  value: HomeView;
  onChange: (view: HomeView) => void;
  // The manager's own visit in progress ("الان") or starting soon (its time), flagged while on «سالن».
  myVisit?: string;
};

// «سالن | برنامه‌ی من» on the home of a manager who also takes clients.
export default function HomeViewSwitch({ value, onChange, myVisit }: Props) {
  return (
    <div className={classes.viewSwitch} role="group" aria-label="نمای خانه">
      <button type="button" aria-pressed={value === "salon"} onClick={() => onChange("salon")}>
        سالن
      </button>
      <button type="button" aria-pressed={value === "me"} onClick={() => onChange("me")}>
        برنامه‌ی من
        {value === "salon" && myVisit && <span className={classes.viewSwitchChip}>{myVisit}</span>}
      </button>
    </div>
  );
}
